<template>
<div class="chapter">
<div class="inner_page">
<h3 class="heading">2.</h3>
<p class="basic-paragraph">Rino’s mother is named Raffaella Cerullo, but everyone has always called her Lina. Not me, I’ve never used either her first name or her last. To me, for more than sixty years, she’s been Lila. If I were to call her Lina or Raffaella, suddenly, like that, she would think our friendship was over.</p>
<p class="basic-paragraph">It’s been at least three decades since she told me that she wanted to disappear without leaving a trace, and I’m the only one who knows what she means. She never had in mind any sort of flight, a change of identity, the dream of making a new life somewhere else. And she never thought of suicide, repulsed by the idea that Rino would have anything to do with her body, and be forced to attend to the details. She meant something different: she wanted to vanish; she wanted every one of her cells to disappear, nothing of her ever to be found. And since I know her well, or at least I think I know her, I take it for granted that she has found a way to disappear, to leave not so much as a hair anywhere in this world.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// neapolitan-novels-boxed-set_00005.vue?8461ac2a